// @flow

export const isOk = (status: number): boolean => {
    return status >= 200 && status < 300;
};
